export const GET_ENTITY_SCREEN = 'entityScreen/GET_ENTITY_SCREEN'
export const START_LOADING_ENTITY_SCREEN = 'entityScreen/START_LOADING_ENTITY_SCREEN'
export const STOP_LOADING_ENTITY_SCREEN = 'entityScreen/STOP_LOADING_ENTITY_SCREEN'
export const SET_ENTITY_SCREEN_STATUSES = 'entityScreen/SET_ENTITY_SCREEN_STATUSES'
export const INVALIDATE_ENTITY_SCREEN = 'entityScreen/INVALIDATE_ENTITY_SCREEN'
export const ENTITY_SCREEN_LOAD_FAILED = 'entityScreen/ENTITY_SCREEN_LOAD_FAILED'
